import * as Const from '../constants';

import Validated from '../interfaces/Validated';

export const validate = ({
  product, package_, dateFrom, dateTo, fieldsArea, planePrice, typePayment,
}): Validated => {

  const caseForm = [Const.PRODUCT];
  const productsWithFieldArea = [Const.CROP_MONITORING, Const.FORESTRY];

  if (product) {
    caseForm.push(Const.PACKAGE);
  } else {
    return {
      formRender: caseForm,
      isFormReady: false,
    };
  }

  if (productsWithFieldArea.includes(product) && package_ === Const.PACKAGE_PROFESSIONAL) {
    caseForm.push(Const.FIELDS_AREA);
  }

  if (product === Const.CROP_MONITORING && package_ === Const.PACKAGE_PROFESSIONAL) {
    if (fieldsArea) {
      caseForm.push(Const.TYPE_PAYMENT, Const.PLANE_PRICE);
    } else {
      return {
        formRender: caseForm,
        isFormReady: false,
      };
    }
  } else if (package_) {
    caseForm.push(Const.TYPE_PAYMENT, Const.PLANE_PRICE);
  } else {
    return {
      formRender: caseForm,
      isFormReady: false,
    };
  }

  if ((planePrice === 0 || planePrice) && typePayment) {
    caseForm.push(Const.DATE_FROM, Const.DATE_TO);
  } else {
    return {
      formRender: caseForm,
      isFormReady: false,
    };
  }

  if (dateFrom && dateTo) {
    return {
      formRender: caseForm,
      isFormReady: true,
    };
  } else {
    return {
      formRender: caseForm,
      isFormReady: false,
    };
  }
};
